// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cg-2";
export var aiChatCartContainerExit = "_cg-4";
export var aiChatContainerLarge = "_cg-0";
export var aiChatContainerSmall = "_cg-1";
export var aiChatIcon = "_cg-6";
export var slideInFromRight = "_cg-3";
export var slideOutToRight = "_cg-5";